<!--
 * @Description: 泵工异常处理
 * @Author: wangwangwang
 * @Date: 2020-12-10 17:29:24
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-06-30 11:12:14
-->
<template>
  <div class="flows-content">
    <el-container>
      <el-main style="margin-bottom: 20px; padding: 0;">
        <el-container direction="vertical">
          <FlowHeader :isReadOnly="readOnly" @saveSubmit="handleSubmit(1)" @sendSubmit="handleSubmit(2)" @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)" @handleAssign="handleSubmit(5)" @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)" @handleNode="handleSubmit(8)" @handleNodeImage="handleSubmit(9)" @handleCollection="handleSubmit(10)" />
          <el-main class="info">
            <div>
              <el-input v-model="title" class="flow-title" :disabled="$route.query.type*1!==1" placeholder="请输入流程标题"></el-input>
            </div>
            <div class="info-top">
              <div class="left">
                <span>单据号码：{{billCode}}</span>
                <span class="text">制单日期：{{billDate}}</span>
              </div>
              <div class="right">
                <span>发起人：{{applyPerson}}</span>
                <span class="text">状态：{{taskTypeText[taskStatus*1]}}</span>
              </div>
            </div>
            <div style="margin-top:20px;">
              <el-form disabled :inline="true" :model="formData" label-width="110px">
                <el-form-item>
                  <span slot="label">异常类型</span>
                  <el-input v-model="formData.typeName"></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label">异常描述</span>
                  <el-input v-model="formData.excepDescription"></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div class="file-container">
              <div v-for="(item, index) in fileList" :key="index" class="file-list">
                <video v-if="item.attachmentUrl.indexOf('mp4')>0" controls="controls" controlspreload="none" style="width:100%;height:100%;">
                  <source :src="process.env.VUE_APP_API_HOST+item.attachmentUrl" />
                </video>
                <el-image v-else style="width:100%;height:100%;" :src="process.env.VUE_APP_API_HOST+item.attachmentUrl" :preview-src-list="[process.env.VUE_APP_API_HOST+item.attachmentUrl]" :z-index="10000">
                </el-image>
              </div>
            </div>
            <div class="flows-details">
              <FlowContent ref="flowcontent" :title='title' :showSendVisible="showSendVisible" @handleCancel="handleCancel" @sendCode="sendCode" @handleFinish="handleFinish" @handleBusiness="handleBusiness" />
            </div>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import FlowContent from '@/components/WorkFlow/flowContent';
import FlowHeader from '@/components/WorkFlow/flowHeader';
import { SaveSpringBack } from '@/api/smart/checkout';
export default {
  components: {
    FlowContent,
    FlowHeader,
  },
  data() {
    return {
      type: 0,
      title: '',
      billCode: '',
      billDate: '',
      applyPerson: '',
      taskTypeText: ['发起', '已保存', '审批中', '已完成', '撤销', '不通过'],
      taskStatus: 0,
      showSendVisible: false,
      readOnly: false,
      formData: {},
      fileList: [],
    }
  },
  methods: {
    handleBusiness() {
      const params = {
        process_success: {
          url: '/icps/system/sign/basics/exception/save_or_update',
          data: {
            engineeringId: this.formData.engineeringId,
            typeId: this.formData.typeId,
            typeName: this.formData.typeName,
            excepDescription: this.formData.excepDescription,
            businessType: this.formData.businessType,
            attachmentList: this.formData.attachmentList,
          },
          httpMethod: 'post',
        },
        process_failure: ''
      }
      this.showSendVisible = false;
      this.$refs.flowcontent.handleToFlow(params);
    },
    /**
     * @Description: 
     * @Param: 1为保存，2为最后提交/3 中间提交
     * @Author: wangwangwang
     * @param {*} type
     */
    handleFinish(type) {
      if (type === 1) {
        if (this.formData.needMaintenance) {
          SaveSpringBack({ id: this.formData.planId })
        }
      }
    },
    handleSubmit(type) {
      const { query } = this.$route;
      if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) { // 提交流程
        this.showSendVisible = true;
        return
      }
      const data = {
        dataSource: 'ExceptionsApply1',
        dataContent: JSON.stringify({ ...this.formData }), // 业务数据
      }
      this.$refs.flowcontent.saveFlows(type, data);
    },
    handleCancel() {
      this.showSendVisible = false;
    },
    /**
     * @Description: 回显业务数据
     * @Param: 
     * @Author: wangwangwang
     */
    initFlowsData(data) {
      this.formData = data;
    },
    initFlowsData2() {
      const { query } = this.$route;
      this.formData = JSON.parse(query.dataContent);
      this.title = query.taskName;
      this.billCode = query.receiptNumber;
      this.billDate = query.createTime;
      this.fileList = this.formData.attachmentList;
      this.applyPerson = query.createUserName;
      this.taskStatus = query.taskStatus;
    },
    sendCode(code) {
      this.billCode = code;
    },
    handleFlowChat() {
      this.$refs.flowcontent.showFlowNode()
    },
  },
  mounted() {
    this.initFlowsData2();
    const { query } = this.$route;
    if (query.isReadOnly*1===1) {
      this.readOnly = true;
    }
  }
}
</script>
<style lang="scss" scoped>
.flows-details {
  margin-top: 20px;
}
.info {
  padding: 0 20px;
  background: #fff;
  .info-top {
    font-size: $font_size;
    color: #000000;
    @include discen_al;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px #e1e5ed solid;
    .left {
      @include discen_al;
    }
    .text {
      margin-left: 60px;
    }
  }
}
.nav_title {
  @include discen_al;
  align-items: flex-end;
  > div {
    width: 4px;
    height: 24px;
    background: $bg_color;
    margin-right: 10px;
  }
  i {
    margin-left: 5px;
  }
  color: $bg_color;
  font-size: 20px;
  font-weight: bold;
}
.file-list {
  height: 100%;
}
</style>
